// MakeAxiosCall.js
import axios from 'axios';

const MakeAxiosCall = async (options) => {
    try {
        return await axios({
            timeout: 60000,
            withCredentials: true,
            ...options,
        });
    } catch (error) {
        console.error('Error while calling API:', error);

        if (error?.response?.status === 401) {
            // Redirect to home page if unauthorized
            window.location.href = '/login';
        }

        return { data: { data: { data: [] } } };
    }
};

export const AXIOS_HELPERS = { MakeAxiosCall };
